module.exports = __webpack_public_path__ + "static/img/Lei-li-formal.be236ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Lei-li-formal.jpg
// module id = 1556
// module chunks = 5